import moment from 'moment';
import { StyledStatistic } from '../StyledStatistic';
import * as S from './styles';
const ConvertedFeeStatistic = props => {
  return <>
      <StyledStatistic title={props.title} value={props.value} precision={props.precision} prefix={props.prefix} suffix={props.suffix} loading={props.loading} />
      <S.ConvertedOn>
        Rate used:{' '}
        {props.loading ? '...' : moment(props.conversionDate).format('DD/MM/YY')}
      </S.ConvertedOn>
    </>;
};
export default ConvertedFeeStatistic;